import type { ResumeTemplate } from '../types';

export const RESUME_TEMPLATES: ResumeTemplate[] = [
  {
    id: 'professional',
    name: 'Professional',
    description: 'Corporate-friendly design for business roles',
    thumbnail: '/images/resume-templates/professional.png',
    supportsProfilePhoto: true,
  },
  {
    id: 'ats-optimized',
    name: 'ATS Optimized',
    description: 'ATS-first, parsing-safe resume layout with standard section headings',
    thumbnail: '/images/resume-templates/professional.png',
    supportsProfilePhoto: false,
  },
  {
    id: 'focus-sidebar',
    name: 'Focus Sidebar',
    description: 'Left-side highlights with right-side deep experience narrative',
    thumbnail: '/images/resume-templates/professional.png',
    supportsProfilePhoto: true,
  },
  {
    id: 'classic',
    name: 'Classic',
    description: 'Traditional two-column layout with a timeless design',
    thumbnail: '/images/resume-templates/classic.png',
    supportsProfilePhoto: true,
  },
  {
    id: 'modern',
    name: 'Modern',
    description: 'Clean, contemporary design with a fresh look',
    thumbnail: '/images/resume-templates/modern.png',
    supportsProfilePhoto: true,
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Simple and elegant with focus on content',
    thumbnail: '/images/resume-templates/minimal.png',
    supportsProfilePhoto: false,
  },
  {
    id: 'creative',
    name: 'Creative',
    description: 'Stand out design for creative industries',
    thumbnail: '/images/resume-templates/creative.png',
    supportsProfilePhoto: true,
  },
  {
    id: 'executive',
    name: 'Executive',
    description: 'Sophisticated layout for senior positions',
    thumbnail: '/images/resume-templates/executive.png',
    supportsProfilePhoto: true,
  },
  {
    id: 'technical',
    name: 'Technical',
    description: 'Skills-focused layout for tech professionals',
    thumbnail: '/images/resume-templates/technical.png',
    supportsProfilePhoto: false,
  },
  {
    id: 'academic',
    name: 'Academic',
    description: 'Structured format for research and academia',
    thumbnail: '/images/resume-templates/academic.png',
    supportsProfilePhoto: false,
  },
  {
    id: 'compact',
    name: 'Compact',
    description: 'Fit more content on a single page',
    thumbnail: '/images/resume-templates/compact.png',
    supportsProfilePhoto: false,
  },
  {
    id: 'elegant',
    name: 'Elegant',
    description: 'Sophisticated typography and refined style',
    thumbnail: '/images/resume-templates/elegant.png',
    supportsProfilePhoto: false,
  },
];

export function getTemplate(id: string): ResumeTemplate | undefined {
  return RESUME_TEMPLATES.find((t) => t.id === id);
}

/**
 * Whether the template with this id prints a profile photo.
 *
 * Photo-free by default, so an id that has not opted in — including one added
 * later, or one that is not in the registry at all — never leaks a photo onto a
 * layout that has no place for it. `ats-optimized` opts out because photos
 * derail resume parsers; the `minimal` family opts out by design.
 */
export function templateSupportsProfilePhoto(templateId?: string): boolean {
  if (!templateId) return false;
  return getTemplate(templateId)?.supportsProfilePhoto === true;
}

export function getDefaultTemplate(): ResumeTemplate {
  return RESUME_TEMPLATES.find((template) => template.id === 'professional') ?? RESUME_TEMPLATES[0];
}
